var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.014 18.878c4.099 0 6.866-3.55 6.866-6.865h1.566c0 4.072-3.394 8.432-8.432 8.432s-8.432-4.36-8.432-8.432c0-4.073 3.394-8.432 8.432-8.432 2.741 0 4.96 1.357 6.344 2.871l-.052-3.759 1.566-.026.105 6.683-6.683-.104.026-1.567 4.098.052c-1.096-1.305-3.002-2.61-5.403-2.61-3.316 0-6.866 2.767-6.866 6.866 0 3.34 2.767 6.891 6.865 6.891Z",
    fill: "#424242"
  })));
};

export default SvgReload;